import { createFileRoute } from "@tanstack/react-router";
import SaintCoralSpringsPage from "@/pages/learn/SaintCoralSpringsPage";
import { page4 } from "@/pages/learn/learnDataP4";
export const Route = createFileRoute(
  "/learn/saint-tms-coral-springs-south-florida",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT TMS Near Me: Coral Springs & South Florida Clinic",
        },
        {
          name: "description",
          content:
            "Where to get SAINT TMS in Florida: why it is scarce, how to vet a provider, and what to plan for at Neuro Wellness TMS Centers of America in Coral Springs.",
        },
        {
          property: "og:title",
          content: "SAINT TMS Near Me: Coral Springs & South Florida Clinic",
        },
        {
          property: "og:description",
          content:
            "Where to get SAINT TMS in Florida: why it is scarce, how to vet a provider, and what to plan for at Neuro Wellness TMS Centers of America in Coral Springs.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/saint-tms-coral-springs-south-florida",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-tms-coral-springs-south-florida",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page4.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintCoralSpringsPage />;
}
